// #region Imports

import Vue from 'vue';
import BaseHeader from '@/layout/BaseHeader';
import Page from '@/layout/Page';
import Sidebar from '@/layout/Sidebar';
import PageTemplateRenderer from '@/layout/PageTemplateRenderer';

// #endregion

// #region Component Registration

Vue.component('BaseHeader', BaseHeader);
Vue.component('PageTemplateRenderer', PageTemplateRenderer);
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Page', Page);
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Sidebar', Sidebar);

// #endregion
